<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>公务员职务与职级并行规定</h1>
        <div class="first">
          <p>近日，中共中央办公厅印发了《公务员职务与职级并行规定》，并发出通知，要求各地区各部门认真遵照执行。</p>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
         <div class="xh"></div>

        <div class="second">
          <strong>
            <P>第一章 总则</P>
          </strong>
          <p>第一条 为了深化公务员分类改革，推行公务员职务与职级并行、职级与待遇挂钩制度，健全公务员激励保障机制，建设忠诚干净担当的高素质专业化公务员队伍，根据《中华人民共和国公务员法》等有关法律法规，制定本规定。</p>
          <p>第二条 国家根据公务员职位类别和职责设置公务员领导职务和职级序列。</p>

          <p>本规定所称职级，是公务员的等级序列，是与领导职务并行的晋升通道，体现公务员政治素质、业务能力、资历贡献，是确定工资、住房、医疗等待遇的重要依据，不具有领导职责。</p>

          <p>公务员可以通过领导职务或者职级晋升。担任领导职务的公务员履行领导职责，不担任领导职务的职级公务员依据隶属关系接受领导指挥，履行职责。</p>

          <p>第三条 实行公务员职务与职级并行制度旨在适应推进国家治理体系和治理能力现代化的要求，完善中国特色公务员制度，改革公务员职务设置办法，建立职级序列，畅通职级晋升通道，拓展职级晋升空间，促进公务员立足本职安心工作，加强专业化建设，激励公务员干事创业、担当作为。</p>

          <p>第四条 公务员职务与职级并行制度坚持以马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观、习近平新时代中国特色社会主义思想为指导，贯彻新时代党的组织路线，坚持党管干部原则，坚持德才兼备、以德为先，坚持五湖四海、任人唯贤，坚持事业为上、公道正派，坚持向基层倾斜，坚持严管和厚爱结合、激励和约束并重。</p>

          <p>第五条 公务员职务与职级并行制度实施工作，由各级党委（党组）及其组织（人事）部门分级负责。中央公务员主管部门负责全国公务员职务与职级并行制度组织实施的宏观指导。县级以上地方各级公务员主管部门具体指导本辖区内公务员职务与职级并行制度的组织实施工作。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
.date{
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
</style>